<template>
    <div id="recruiter_new_candidates" class="flex_content">

        <div id="context_bar">
            <TopbarGoPositionsList/>
            <TopbarSteps />
        </div>

        <transition :name="stepAnim">
            <component :is="currentStepComponent" :is-new="true"></component>
        </transition>
    </div>

</template>

<script>
import TopbarGoPositionsList from "../components/topbar/topbarGoPositionsList"
import TopbarSteps from "../components/topbar/topbarSteps"

import FormStep1 from "../components/form/formStep1"
import FormStep2 from "../components/form/formStep2"
import FormStep3 from "../components/form/formStep3"
import FormStep4 from "../components/form/formStep4"
import FormStep5 from "../components/form/formStep5"
import FormStep6 from "../components/form/formStep6"


export default {
    name: 'PositionNew',
    components: {
        TopbarGoPositionsList,
        TopbarSteps,
        FormStep1,
        FormStep2,
        FormStep3,
        FormStep4,
        FormStep5,
        FormStep6
    },
    beforeCreate() {
        this.$store.dispatch('PositionStore/initNew')
        this.$store.dispatch('RefStore/indexCats', "saven")
        this.$store.dispatch('RefStore/indexCats', "custom")
        this.$store.dispatch('RefStore/indexRefs', "saven")
        this.$store.dispatch('RefStore/indexRefs', "custom")
        this.$store.dispatch('RefStore/indexCats', "custom_company")
        this.$store.dispatch('RefStore/indexRefs', "custom_company")
    },
    data(){
        return {
            stepAnim: "tab-slide-right"
        }
    },
    computed: {
        currentStepComponent(){
            return this.$store.state.PositionStore.formStepsName[this.$store.state.PositionStore.formCurrentStep]
        }
    },
    watch: {
        currentStepComponent: function(newVal, oldVal){
            const newIndex = this.$store.state.PositionStore.formStepsName.indexOf(newVal)
            const oldIndex = this.$store.state.PositionStore.formStepsName.indexOf(oldVal)
            if(newIndex > oldIndex){
                this.stepAnim = "tab-slide-right"
            }else{
                this.stepAnim = "tab-slide-left"
            }


        }
    }
}
</script>

<style lang="scss">
    .steps_nav{
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>

